import { useState, useEffect } from "react";
import api from "../../services/api";
import Spinner from "../../shared/Spinner/Spinner";
import Style from "./InstallmentsDetailsStyle";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import PageTitle from "../../components/PageTitle";
import ReturnButton from "../../components/Buttons/ReturnButton";

export default function InstallmentsDetail(props) {

  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const [id, setId] = useState("");
  const [installment, setInstallment] = useState("");
  const [interestRate, setInterestRate] = useState("");
  const [maxDate, setMaxDate] = useState("");

  const [successMessage, setSuccessMessage] = useState<string>();
  const [errorMessage, setErrorMessage] = useState<string>();
  const propsId: number = props.match.params.installmentId;
  const creatingNew = propsId <= 0;
  useEffect(() => {
    if (!creatingNew) {
      LoadInstallment(propsId);
    } else {
      setLoading(false);
    }
  }, []);

  async function LoadInstallment(propsId) {
    try {
      const result = await api.get(`/installment/${propsId}`);
      if (result.data.success) {
        let installment = result.data.installment;
        setId(installment.id);
        setInstallment(installment.installment);
        setInterestRate(installment.interestRate);
        const date = new Date(installment.maxDate);
        setMaxDate(date.toISOString().substr(0, 10));
        setLoading(false);
      }
    } catch (error) {
      console.error("Erro ao buscar a parcela selecionada: ", error);
      setLoading(false);
    }
  }


  function OnSubmit() {
    if (creatingNew) {
      onCreate()
    } else {
      onEdit()
    }
  }

  async function onCreate() {
    try {
      setLoading(true);
      let installmentParse = parseInt(installment);
      let interestRateParse = parseFloat(interestRate).toFixed(3);
      const data = {
        installment: installmentParse, interestRate: interestRateParse, maxDate
      }
      const request = api.post(`/installments/create`, data);
      const result = await request;
      onClosePopup();
      setSuccessMessage("Criou parcela com sucesso, id: " + result.data.installmentId);
      setLoading(false);
      props.history.goBack();
    }
    catch (error: any) {
      setLoading(false);
      setErrorMessage(error?.response?.data?.message);
    }
  }

  async function onEdit() {
    try {
      setLoading(true);
      let installmentParse = parseInt(installment);
      let interestRateParse = parseFloat(interestRate).toFixed(3);
      const data = {
        id, installment: installmentParse, interestRate: interestRateParse, maxDate
      }
      const request = api.put(`/installments/edit`, data);
      const result = await request;
      onClosePopup();
      setSuccessMessage("Editou parcela com sucesso, id: " + result.data.adminId);
      setLoading(false);
      props.history.goBack()
    }
    catch (error: any) {
      setLoading(false);
      onClosePopup();
      setErrorMessage(error?.response?.data?.message);
    }
  }

  function onOpenPopUp() {
    setShowPopup(true);
  }

  function onClosePopup() {
    setShowPopup(false);
  }


  function onRate(value) {
    const newRate = parseFloat(value);
    if (newRate !== undefined && newRate >= 0 && newRate <= 999.999) {
      value = value.replace(/(d)(d{3})(d{3}),/g, "$1.$2.$3,");
      value = value.replace(/(d)(d{3}),/g, "$1.$2,");
      value = value.replace("-", '')
      value = value.replace("+", '')
      const splits = value.split(".");
      if (splits[1]) {
        value = splits[0] + "." + splits[1].substr(0, 3);
      }
      setInterestRate(value);
    }
  }

  return (
    <Style className="default-page">
      <PageTitle title="Detalhes da Parcela" />
      <TwoButtonsModal
        show={showPopup}
        onHide={onClosePopup}
        loading={loading}
        title="Deleção de parcela!"
        body={"Você tem certeza que deseja " + (creatingNew ? " cadastrar esta parcela?" : " editar esta parcela?")}
        secondaryText="Fechar"
        secondaryOnClick={onClosePopup}
        secondaryDisabled={loading}
        primaryText="Confirmar"
        primaryOnClick={() => OnSubmit()}
        primaryDisabled={loading}
      />
      <ReturnButton history={props.history} />
      <Spinner spinning={loading} />
      {errorMessage && <p className="alert">Erro: {errorMessage}</p>}
      {successMessage && <p className="alert alert-info">{successMessage}</p>}
      <main>
        <div className="panel">
          <form className="main-form" onSubmit={(e) => { e.preventDefault(); }}>
            <h2>Cadastro de parcelas</h2>
            <div>
              <label>Parcelas:</label>
              <input
                type="number"
                min="0"
                max="9999"
                disabled={loading}
                value={installment || 0}
                onChange={e => (parseInt(e.target.value) >= 0 && e.target.value.length <= 4) ? setInstallment(e.target.value) : null}
              />
            </div>
            <div>

            </div>
            <div>
              <label>Juros %:</label>
              <input
                type="number"
                disabled={loading}
                value={interestRate}
                onChange={e => onRate(e.target.value)}
                onBlur={e => onRate(e.target.value)}
              />
            </div>

            <div>
              <label>Data limite:</label>
              <input
                type="date"

                disabled={loading}
                value={maxDate || ""}
                onChange={e => setMaxDate(e.target.value)}
              />
            </div>

            <button
              className="btn btn-success btn-lg mt-4"
              type="button"
              disabled={loading}
              onClick={e => {
                e.preventDefault();
                onOpenPopUp();
              }}>{creatingNew ? "Criar" : "Editar"}
            </button>

          </form>
        </div>
      </main>
    </Style>
  );
}
